const defaultTableState = {
  pagination: {
    PageNumber: 0,
    PageSize: 100,
  },
};

export default defaultTableState;
